import { uploadProCompletionImg } from "../apiHelpers/provider/list";


export const bookingCompletionImageUpload = (params, done) => async dispatch => {
    console.log("ADDITIONALLLL IMAGE PARAMSSSS 3333",params)
    try {
        const data = await uploadProCompletionImg(params);
        console.log("ADDITIONALLLL IMAGE IN USERS.JS DATA 4444",data)
        if (data.status === 'OK') {
            return done(true, data);
           
        }
        else {
            return done(false, data.message);
        }
    } catch (e) {
        console.log(e);
    }
};


// WEBPACK FOOTER //
// ./src/actions/Provider.js